import { FC } from 'react'
import { SpaceSheetProvider } from '../spaceSheet/SpaceSheetContext'
import SpaceSidebar from '../spaceSheet/SpaceSidebar'
import { SpaceListViewProvider } from '../../context/SpaceListViewContext'
import { Spaces } from '../../Spaces'

const SpacesListWrapper: FC = () => {
  return (
    <SpaceSheetProvider>
      <SpaceSidebar />
      <SpaceListViewProvider>
        <Spaces />
      </SpaceListViewProvider>
    </SpaceSheetProvider>
  )
}

export default SpacesListWrapper
